import { Link } from 'react-router-dom';
import { Music, Calendar, Users, Globe } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-6">About Nokset</h1>

      <div className="space-y-6 text-gray-300 leading-relaxed">
        <p className="text-lg">
          Nokset is a platform built for bands, by music lovers. We believe every band
          deserves a central, professional place to manage their gigs, share their schedule
          with the public, and keep their band organised.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 my-8">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
            <Globe className="w-8 h-8 text-indigo-400 mb-3" />
            <h3 className="font-semibold text-gray-50 mb-1">Public Band Pages</h3>
            <p className="text-sm text-gray-400">
              Professional public pages where fans and venues can see your upcoming gigs,
              learn about your band, and explore your setlists.
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
            <Calendar className="w-8 h-8 text-indigo-400 mb-3" />
            <h3 className="font-semibold text-gray-50 mb-1">Smart Calendar</h3>
            <p className="text-sm text-gray-400">
              Manage all your events in one place. Choose what's public (gigs) and
              what's private (rehearsals, meetings). Your single source of truth.
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
            <Users className="w-8 h-8 text-indigo-400 mb-3" />
            <h3 className="font-semibold text-gray-50 mb-1">Team Management</h3>
            <p className="text-sm text-gray-400">
              Invite band members by email. If they already have an account, they get
              instant access. If not, they'll receive an invitation.
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-5">
            <Music className="w-8 h-8 text-indigo-400 mb-3" />
            <h3 className="font-semibold text-gray-50 mb-1">Setlist Manager</h3>
            <p className="text-sm text-gray-400">
              Create and manage your setlists. Share them publicly for fans or
              keep them private for band reference.
            </p>
          </div>
        </div>

        <p>
          Whether you're a pub band in Guernsey, a jazz trio in London, or a rock group
          in Nashville, Nokset gives you the tools to stay organised and connected.
        </p>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mt-8 text-center">
          <h2 className="text-xl font-semibold text-gray-50 mb-2">Ready to get started?</h2>
          <p className="text-gray-400 mb-4">Create your free account and set up your band in minutes.</p>
          <Link
            to="/signup"
            className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg font-medium transition"
          >
            Sign Up Free
          </Link>
        </div>

        <div className="mt-8 text-center text-sm text-gray-500">
          <p>Questions? Contact us at <a href="mailto:hello@nokset.com" className="text-indigo-400 hover:text-indigo-300">hello@nokset.com</a></p>
        </div>
      </div>
    </div>
  );
}
